'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentPaceAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "#F6F4F1",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.7976 19C12.5281 19 10.9198 20.5666 10.1156 22.8898C9.85432 22.7189 9.65102 22.4712 9.53309 22.18C9.41516 21.8888 9.38826 21.5681 9.45601 21.261L9.91532 19.1707H4C4.00002 19.5801 4.10184 19.9829 4.29612 20.3421C4.4904 20.7013 4.7709 21.0053 5.11181 21.2262L6.56274 22.1636V32.9867C6.56287 33.9213 6.3285 34.8407 5.88156 35.6588C5.43462 36.477 4.78971 37.1672 4.00715 37.6648V39H13.2536C13.2526 38.5933 13.1486 38.1937 12.9515 37.8392C12.7543 37.4846 12.4707 37.1871 12.1275 36.9748L10.6694 36.0737L10.6408 31.4302C11.5594 33.1661 13.0519 34.3334 15.0623 34.3334C18.5365 34.3334 21.3797 30.908 21.3797 26.6667C21.3797 22.4254 18.3576 19 14.7976 19ZM14.1651 32.1491C12.2119 32.1491 11.0357 29.6538 10.8912 27.3611C10.7466 25.0683 11.3204 21.7861 13.6199 21.7861C16.1755 21.7861 16.8938 24.7471 17.0655 26.8085C17.2372 28.8698 16.8065 32.1491 14.1651 32.1491Z",
          fill: "#262324"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M38.5551 32.1099L37.2244 31.1653V24.7846C37.2244 19.995 33.4912 19.0649 31.2804 19.0649C28.6963 19.0649 27.8062 19.6435 24.6983 19.3542V24.7325H25.7901C27.7719 24.7325 27.5988 21.1335 30.3561 21.1335C32.4524 21.1335 33.142 22.5554 33.142 24.501V24.5878C32.0216 24.7918 30.4991 25.0536 28.805 25.3718C25.6756 25.9823 23.7511 27.4911 23.7511 30.3075C23.7511 32.716 25.8187 34.3998 28.6047 34.3998C31.103 34.3998 32.8544 32.9778 33.8589 30.539C34.1288 30.6863 34.3409 30.9222 34.4605 31.2077C34.5802 31.4932 34.6001 31.8114 34.5171 32.1099L33.9219 34.2233H39.6369C39.6385 33.809 39.541 33.4003 39.3526 33.0323C39.1642 32.6643 38.8906 32.3479 38.5551 32.1099ZM29.8739 31.8336C28.7534 31.8336 27.9779 30.9324 27.9493 29.8301C27.9403 29.1787 28.1561 28.5446 28.5596 28.0366C28.963 27.5287 29.529 27.1787 30.16 27.047C31.2804 26.7866 32.2849 26.5826 33.1477 26.438C33.1477 30.8514 31.1946 31.8394 29.8739 31.8394V31.8336Z",
          fill: "#262324"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M51.9551 30.3872C51.2364 30.8617 50.4007 31.1233 49.5425 31.1423C46.6436 31.1423 45.1497 28.6744 45.1497 26.0909C45.1497 23.2166 46.7866 21.1553 48.9688 21.1553C50.1464 21.1553 50.9506 21.6196 51.5244 22.4037C52.0695 23.1269 52.3829 24.1395 52.6161 25.3358H54.2531V19.2357C51.9851 19.8143 51.1223 19.0607 48.2519 19.0607C44.3456 19.0607 40.9286 22.4861 40.9286 26.7274C40.9286 30.9687 43.9149 34.3941 48.5667 34.3941C52.1282 34.3941 54.3675 31.028 54.8269 29.3731L53.5391 28.7945C53.1327 29.4362 52.5919 29.9798 51.9551 30.3872Z",
          fill: "#262324"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M64.5898 19.0649C60.5132 19.0649 57.1821 22.4903 57.1821 26.7316C57.1821 30.9729 60.5132 34.3983 64.5898 34.3983C68.1227 34.3983 70.4568 31.932 71.1951 30.1903C70.8263 29.9865 70.4065 29.8983 69.988 29.937C69.5701 29.9756 69.1727 30.1394 68.8467 30.4073C68.1153 30.9814 67.2112 31.2837 66.2854 31.2636C63.1547 31.2636 61.605 28.9419 61.4604 27.0831C61.4319 26.8227 61.4319 26.5899 61.4033 26.328H71.4826V25.9519C71.4826 22.026 68.4102 19.0649 64.5898 19.0649ZM61.5463 24.2985C61.8626 22.5844 62.6911 21.2796 64.245 21.2796C65.9979 21.2796 66.974 22.9634 67.29 24.2985H61.5463Z",
          fill: "#262324"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M76.9822 34.2627C78.5557 33.8873 79.5305 32.2932 79.1592 30.7024C78.7879 29.1115 77.2107 28.1263 75.6373 28.5017C74.0638 28.8772 73.0889 30.4712 73.4603 32.0621C73.8316 33.6529 75.4088 34.6382 76.9822 34.2627Z",
          fill: "#262324"
        }
      )
    ]
  }
);
const VpPaymentPaceAsset = forwardRef(PaymentPaceAsset);

export { VpPaymentPaceAsset as default };
